var api = require("!../../node_modules/.pnpm/style-loader@1.3.0_webpack@5.105.4/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../node_modules/.pnpm/file-loader@6.2.0_webpack@5.105.4/node_modules/file-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../node_modules/.pnpm/extract-loader@5.1.0/node_modules/extract-loader/lib/extractLoader.js!../../node_modules/.pnpm/css-loader@3.6.0_webpack@5.105.4/node_modules/css-loader/dist/cjs.js?-url!../../node_modules/.pnpm/postcss-loader@3.0.0/node_modules/postcss-loader/src/index.js!../../node_modules/.pnpm/sass-loader@16.0.7_sass-emb_5819c3a6d925e5cc094622f90bbe6c3d/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[2].use[5]!../../node_modules/.pnpm/sass-resources-loader@2.2.5/node_modules/sass-resources-loader/lib/loader.js??ruleSet[1].rules[2].use[6]!./common.scss");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};